export default function Values() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Transparência',
      description: 'Relacionamento ético e confiável com clientes e investidores.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Comprometimento',
      description: 'Cumprimento rigoroso de prazos e responsabilidades.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-award-line',
      title: 'Qualidade',
      description: 'Excelência em cada detalhe de projeto e execução.',
      color: 'from-amber-500 to-amber-600'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Inovação',
      description: 'Adoção de novas tecnologias e soluções construtivas.',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-team-line',
      title: 'Valorização Humana',
      description: 'Respeito e desenvolvimento de colaboradores e parceiros.',
      color: 'from-pink-500 to-pink-600'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustentabilidade',
      description: 'Obras que respeitam o meio ambiente e o entorno urbano.',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <section id="valores" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-6 uppercase tracking-wider">
            Nossos Princípios
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Valores que nos Guiam
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Princípios fundamentais que norteiam cada decisão e ação da Gleimatus Empreendimentos
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-amber-300 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${value.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${value.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom Image */}
        <div className="mt-20 rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="https://public.readdy.ai/ai/img_res/a034700492736973ea40f0cb0bb202aa.jpg"
            alt="Equipe Gleimatus"
            className="w-full h-96 object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}